<template>
  <div class="page-wrap">
    <a-card title="浏览人数与用户动态">
      <div class="toolbar">
        <a-input v-model.trim="query.keyword" placeholder="用户、手机号、搜索词或产品" allow-clear @pressEnter="search" />
        <a-select v-model="query.eventType" placeholder="行为类型" allow-clear>
          <a-select-option value="PRODUCT_VIEW">浏览产品</a-select-option>
          <a-select-option value="PRODUCT_SEARCH">搜索产品</a-select-option>
          <a-select-option value="REGISTER">用户注册</a-select-option>
        </a-select>
        <a-button type="primary" @click="search">查询</a-button>
      </div>
      <a-table row-key="id" :loading="loading" :columns="columns" :data-source="rows"
        :pagination="pagination" @change="changePage">
        <template slot="user" slot-scope="text, record">
          <span>{{ record.userName || '游客' }}</span>
          <span v-if="record.userPhone" class="muted">（{{ record.userPhone }}）</span>
        </template>
        <template slot="event" slot-scope="text, record">{{ eventText(record) }}</template>
        <template slot="source" slot-scope="text">{{ sourceText(text) }}</template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { getUserActivityList } from '@/api'

export default {
  data() {
    return {
      loading: false,
      rows: [],
      query: { keyword: '', eventType: undefined },
      pagination: { current: 1, pageSize: 20, total: 0, showSizeChanger: true },
      columns: [
        { title: '用户', key: 'user', scopedSlots: { customRender: 'user' } },
        { title: '用户行为', key: 'event', scopedSlots: { customRender: 'event' } },
        { title: '来源', dataIndex: 'source', width: 110, scopedSlots: { customRender: 'source' } },
        { title: '发生时间', dataIndex: 'createdAt', width: 180 }
      ]
    }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      getUserActivityList({ ...this.query, page: this.pagination.current, pageSize: this.pagination.pageSize })
        .then(res => {
          const data = res.data || {}
          this.rows = data.records || []
          this.pagination.total = Number(data.total || 0)
        }).finally(() => { this.loading = false })
    },
    search() { this.pagination.current = 1; this.loadData() },
    changePage(page) { this.pagination.current = page.current; this.pagination.pageSize = page.pageSize; this.loadData() },
    eventText(record) {
      if (record.eventType === 'REGISTER') return '注册了商城账户'
      if (record.eventType === 'PRODUCT_SEARCH') {
        const product = record.productModel || record.productName || '暂无匹配产品'
        return `搜索“${record.keyword || ''}”，匹配产品：${product}`
      }
      if (record.eventType === 'PRODUCT_VIEW') return `浏览了产品：${record.productModel || record.productName || '--'}`
      return record.eventType || '--'
    },
    sourceText(source) { return { PC: 'PC端', MINI_PROGRAM: '小程序' }[source] || '未知' }
  }
}
</script>

<style scoped>
.page-wrap { padding: 20px; }
.toolbar { display: flex; gap: 12px; margin-bottom: 16px; }
.toolbar .ant-input { width: 280px; }
.toolbar .ant-select { width: 150px; }
.muted { color: #8c8c8c; }
</style>
